import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { theme } from '../../src/theme';
import { StyledLogo, StyledDefaultSecurityLogo } from './styled-components';
export var SecurityLogo = function SecurityLogo(_ref) {
  var fontSize = _ref.fontSize,
      height = _ref.height,
      logoUrl = _ref.logoUrl,
      securitySymbol = _ref.securitySymbol,
      width = _ref.width,
      className = _ref.className,
      isEtf = _ref.isEtf;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasLogoError = _useState2[0],
      setHasLogoError = _useState2[1];

  if (logoUrl && !isEtf && !hasLogoError) {
    return /*#__PURE__*/React.createElement(StyledLogo, {
      alt: "Security Logo",
      height: height,
      src: logoUrl,
      width: width,
      onError: function onError() {
        return setHasLogoError(true);
      },
      className: className
    });
  }

  return /*#__PURE__*/React.createElement(StyledDefaultSecurityLogo, {
    fontSize: fontSize,
    height: height,
    text: securitySymbol,
    width: width,
    className: className,
    backgroundColor: isEtf && theme.colors.lightOak
  });
};